import BusinessGridItem from './BusinessGridItem';

export default BusinessGridItem;
